<template>
  <div class="script-agent">
    <section class="script-agent__section" v-if="sectionCount == 0">
      <h1 class="script-agent__title">A. OPENING:</h1>
      <br />
      <b>Opening</b>
      <div class="script-agent__question">
        Hi, is this <b>{{ lead.fullname }}</b
        >? Hi <b>{{ lead.fullname }}</b
        >, my name is <b>{{ lead.agent_fullname }}</b
        >, I’m a senior licensed agent with Blueberry Insurance and we’re on a
        recorded line.
      </div>
      <br />
      <div class="script-agent__question">
        <b>Agent, Use the proper Opening depending on the Lead Source.</b>
      </div>
      <b>Value Proposition</b>
      <div class="script-agent__question">
        So, my name again is <b>{{ lead.agent_fullname }}</b>, I’m a senior licensed agent, I’ve been a life insurance agent for
        more than <b>(Agent Years)</b> years. Now, I’m a fully independent agent
        so I don’t work directly for any insurance company, I work on behalf of
        my customers, like you.
      </div>
      <br />
      <div class="script-agent__question">
        Here at Blueberry we search dozens of the best life insurance companies
        to find the one that has the best price and coverage for you, based on
        what you are looking for and all of the different options and discounts
        that are available.
      </div>
      <br />
      <div class="script-agent__question">
        All of the companies I work with are A+ rated carriers like Mutual of
        Omaha, American National, AIG, Foresters, Royal Neighbors, etc.
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 1">
      <h1 class="script-agent__title">B. NEEDS ANALYSIS:</h1>

      <div class="script-agent__question">
        It says here you were looking at quotes for
        <b>${{ lead.coverage_amount }}</b
        >, how did you decide on that amount? (Listen to what they want)
      </div>

      <div class="script-agent__question">
        <span
          :class="lead.insurance || lead.currently_insured ? 'yes-text' : null"
        >
          Do you have any life insurance now? (Listen for what they have)
        </span>
      </div>

      <div class="script-agent__question">
        <span :class="lead.married ? 'yes-text' : null">
          And are you looking for a policy just for yourself, or for your spouse
          also?
        </span>
      </div>

      <div class="script-agent__question">
        Now, when we talk about life insurance, there are 2 factors that are
        important, how much life insurance you want or need, and how long you
        want the policy to last. Have you ever thought about whether you wanted
        to be buried or cremated?
      </div>

      <div class="script-agent__question">
        The reason I ask is because the average cremation, as you know, costs
        less than $5,000, and the typical burial costs around $10,000, so if we
        figure about $10,000 to cover final expenses, does that sound like
        enough?
      </div>

      <div class="script-agent__question">
        <span :class="lead.mortgage ? 'yes-text' : null">
          And if something happened to you unexpectedly, would your
          spouse/significant other need to replace your income to make ends
          meet?
        </span>
        How much would they need on a monthly basis? For how long?
      </div>

      <div class="script-agent__question">
        And then most people want to leave their family debt free. How much
        money would it take to pay off all your debts? Do you want to include
        your mortgage in that?
      </div>

      <div class="script-agent__question">
        Do you have any other things that you would want your family to use the
        life insurance money for?
      </div>

      <div class="script-agent__question">
        So when we add all that up, it comes to about
        <b>${{ lead.coverage_amount }}</b> of life insurance, does that sound
        right to you? How do you feel about that amount?
      </div>

      <div class="script-agent__question">
        Okay. And do you have kids? How old is your youngest kid?
      </div>

      <div class="script-agent__question">
        The reason I ask is because most people want a life insurance policy to
        last at least until the kids are grown. That’s taking longer now-a-days,
        but most people choose a 20-year term insurance policy for that. And if
        I found you a policy that you liked, would your spouse/significant other
        be the beneficiary of that policy?
      </div>

      <div class="script-agent__question">
        Ok, so I’ll look for the best price on a
        <b>${{ lead.coverage_amount }}</b>
        20-year term insurance policy so { beneficiary } doesn’t have to worry
        about that when the time comes. Does that sound right?
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 2">
      <h1 class="script-agent__title">C. FIELD UNDERWRITING:</h1>
      <br />

      <div class="script-agent__question">
        Ok, great, so as you know, the best price I find for you for a life
        insurance policy is based on your age, and your health, and so to make
        sure I find you the least expensive plan available, what I’m going to do
        is verify your information and ask you a few health-related questions
        and that will narrow down the best plan I can get for you, okay?
      </div>
      <div class="script-agent__question">How tall are you?</div>
      <div class="script-agent__question">How much do you weigh?</div>
      <div class="script-agent__question">
        Now, do you smoke or use tobacco or nicotine at all?
      </div>
      <div class="script-agent__question">
        Do you have any type of diabetes?
      </div>
      <div class="script-agent__question">
        Have you ever had asthma, sleep apnea, COPD, or any lung issues at all?
      </div>
      <div class="script-agent__question">
        Have you ever had a heart attack, stroke or any heart surgery?
      </div>
      <div class="script-agent__question">
        Do you have high blood pressure or high cholesterol?
      </div>
      <div class="script-agent__question">
        Do you take any prescription pain medication?
      </div>
      <div class="script-agent__question">Have you ever had cancer?</div>
      <div class="script-agent__question">
        Have you ever had any other major medical issues or surgeries?
      </div>
      <div class="script-agent__question">
        Have you ever taken medication for Anxiety or Depression?
      </div>
      <div class="script-agent__question">
        Do you take any other medication for anything?
      </div>
      <div class="script-agent__question">
        Ok, so now I’m going to check the different insurance companies to see
        which one has the best price for you. We’re looking for a
        <b>${{ lead.coverage_amount }}</b>
        20-year term insurance policy.
      </div>
    </section>
    <section class="script-agent__section" v-else-if="sectionCount == 3">
      <h1 class="script-agent__title">D. POLICY INFO:</h1>
      <br />
      <div class="script-agent__question">
        And when we talk about life insurance coverage, its important to know
        that once the policy is issued and approved the rate and the coverage
        stay level for the length of the term. It is full life insurance, it
        covers everything except suicide, so there are no exclusions in the
        policy,
      </div>

      <div class="script-agent__question">
        And it is full coverage from day one with no waiting period. Which means
        if we get you approved, and you make even just one payment, and then
        something unexpected happens and you die any time after that, the policy
        will pay the full amount to (beneficiary), usually in about a week after
        you pass away. So, it is very quick with no waiting period.
      </div>

      Quote and Agreement

      <div class="script-agent__question">
        Now, it looks like the best company for you is coming back as …
        <b>{{ lead.premium_carrier }}</b
        >, they are a great company, (Give a few talking points) and it is only
        <b>{{ lead.premium_price }}</b> per month.
      </div>

      (Assume the close)

      <div class="script-agent__question">
        What day of the month do you want your payment to be due?
      </div>

      (If the price seems high)

      <div class="script-agent__question">
        Is that comfortable for you or do we need to make an adjustment?
      </div>

      <div class="script-agent__question">Overcome objections.</div>

      <div class="script-agent__question">Move to the application.</div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ScriptTermLife",
  props: {
    lead: Object,
    baseData: Object,
    sectionCount: Number,
  },
  data() {
    return {
      questionCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
};
</script>

<style lang="scss">
.script-agent {
  max-height: 400px;
  overflow: auto;
  &__title {
    text-align: center;
  }
  &__section {
    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px 0;
    }
  }
  &__question {
    border-left: 3px solid red;
    padding-left: 10px;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    &-span {
      cursor: pointer;
      color: red;
    }
    .yes-text {
      text-decoration: underline;
      text-decoration-color: red;
    }
    p {
      display: flex;
      align-items: center;
      margin: 0;
    }
  }
  &__input {
    max-width: 200px;
    margin-right: 20px;
  }
}
</style>